// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('#rightholders');
  }

  @on({ event: 'click', selector: '.cancel-information' })
  onClickCancelInformation() {
    $('.invited-information').addClass('d-none');
  }
}
